<script setup>
const { data: tags } = useFetch('/api/tag')
const { Settings } = useSettings()

const query = ref('')

const filteredTags = computed(() => {
  if (!tags.value) return []
  if (!query.value) { return tags.value }
  return tags.value.filter(t => t.name.toLowerCase().includes(query.value.toLowerCase()))
})
</script>

<template>
<section>
  <Head><Title>{{ Settings.name }} - {{ $t('Tags') }}</Title></Head>
  <h2 class="mb-6">
    {{ $t('Tags') }}
  </h2>
  <v-text-field
    v-model="query"
    :label="$t('Search')"
    prepend-inner-icon="mdi-magnify"
  />
  <section class="container max-w-80">
    <v-chip
      v-for="tag in filteredTags"
      :key="tag.id"
      :to="`/tag/${tag.id}`"
      color="primary"
      label
      class="ma-1"
    >
      {{ tag.name }}
    </v-chip>
  </section>
</section>
</template>
